import { render, staticRenderFns } from "./Account_edit.vue?vue&type=template&id=2910a8d9&"
import script from "./Account_edit.vue?vue&type=script&lang=js&"
export * from "./Account_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports